
import { graphql, type ResultOf } from '@client/shared/graphql';
import { gqlRequest } from '@client/shared/graphql';

export const BookSlotMutation = graphql(`
  mutation BookSlot($listingId: ID!, $start: String!, $end: String!, $agentUserId: ID) {
    bookSlot(listingId: $listingId, start: $start, end: $end, agentUserId: $agentUserId) {
      __typename
      ... on Booking {
        id
        listingId
        startsAt
        endsAt
        agentUserId
      }
      ... on SlotUnavailableError {
        message
      }
      ... on OutsideBookingWindowError {
        message
      }
    }
  }
`);

export type BookSlotData = ResultOf<typeof BookSlotMutation>;
export type BookSlotResult = BookSlotData['bookSlot'];

export interface BookSlotVars {
  readonly listingId: string;
  readonly start: string;
  readonly end: string;
  readonly agentUserId?: string;
}

export function bookSlot(vars: BookSlotVars, signal?: AbortSignal): Promise<BookSlotData> {
  return gqlRequest(BookSlotMutation, vars, { signal });
}
